import { useMemo } from 'react';

import { LabelsContextProvider } from '@hotjar/labels';

import { event } from '@hotjar/webapp/tracking/tools/hotjar';
import { calculateOverflow } from '@hotjar/webapp/lib/calculate-overflow';

interface LabelsContextProps {
  children: React.ReactNode;
}

export const LabelsContext = ({ children }: LabelsContextProps): JSX.Element => {
  const labelsContextObject = useMemo(
    () => ({
      calculateOverflow,
      event,
    }),
    [],
  );

  return <LabelsContextProvider value={labelsContextObject}>{children}</LabelsContextProvider>;
};
